import React, { useEffect, useState } from 'react';
import styles from './site-page.module.css';
import { addDocBd, getDocBd } from '../../firebase';
import LoaderPage from '../../components/LoaderPage/LoaderPage';
import HeaderBack from '../../components/HeaderBack/HeaderBack';

export default function SitePage() {
  const [loaderPage, setLoaderPage] = useState(false);
  const [telegtamGropLink, setTelegtamGropLink] = useState('');
  const [startDateGroup, setStartDateGroup] = useState('');

  const addData = async (value) => {
    setLoaderPage(true);
    const isAddDataBd = await addDocBd('site', 'groupInfo', value);
    if (isAddDataBd) {
      alert('Дані додані успішно.');
    } else {
      alert('Помилка дані не додано.');
    }
    setLoaderPage(false);
  };

  useEffect(() => {
    setLoaderPage(true);
    const getGroupInfo = async () => {
      const groupInfo = await getDocBd('site', 'groupInfo');
      if (groupInfo) {
        setTelegtamGropLink(groupInfo.telegtamGropLink);
        setStartDateGroup(groupInfo.startDateGroup);
      }
      setLoaderPage(false);
    };
    getGroupInfo();
  }, []);

  return (
    <>
      {/* -------------- Header ------------------------ */}
      <HeaderBack />
      {/* -------------- /Header ------------------------ */}

      <div className={styles.content_wrapper}>
        <div>
          Посилання на групу в телеграмі
          <input
            className={styles.input}
            type="text"
            value={telegtamGropLink}
            onChange={(e) => setTelegtamGropLink(e.target.value)}
          />
          <div className={styles.selected_date_wrapper}>
            <div className={!startDateGroup ? styles.selected_date_text_noActive : ''}>
              Дата старту групи
            </div>
            <input
              onChange={(e) => setStartDateGroup(e.target.value)}
              className={
                startDateGroup
                  ? styles.selected_date_input
                  : styles.selected_date_input + ' ' + styles.selected_date_input_noActive
              }
              value={startDateGroup}
              type="date"
              name="date_start_group"
            />
          </div>
          <button
            className={styles.save_btn}
            onClick={() =>
              addData({
                telegtamGropLink: telegtamGropLink.trim(),
                startDateGroup: startDateGroup,
              })
            }>
            Зберегти
          </button>
        </div>
      </div>

      {loaderPage && <LoaderPage />}
    </>
  );
}
